import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

const TITLES = {
  terms: "Terms & Conditions",
  privacy: "Privacy Policy",
  shipping: "Shipping Policy",
  returns: "Returns & Refunds",
  imprint: "Imprint / Legal Notice",
};

export default function Legal() {
  const { slug } = useParams();
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/legal").then((r) => setContent(r.data)).catch(() => setContent({}));
  }, []);

  const title = TITLES[slug] || "Legal";
  const body = content?.[slug];

  return (
    <div className="pt-28 lg:pt-36 pb-24 max-w-[900px] mx-auto px-6 lg:px-12 min-h-[60vh]">
      <p className="font-mono-label text-xs uppercase tracking-luxe text-white/40 mb-6">Legal</p>
      <h1 className="font-serif-display text-5xl lg:text-6xl font-light uppercase tracking-tight mb-12" data-testid="legal-title">
        {title}
      </h1>
      {content === null ? (
        <p className="text-white/40 font-mono-label text-sm uppercase tracking-luxe">Loading…</p>
      ) : body ? (
        <div className="text-white/70 leading-relaxed whitespace-pre-wrap" data-testid="legal-body">{body}</div>
      ) : (
        <div className="border border-white/10 p-8 text-white/50" data-testid="legal-placeholder">
          <p className="mb-4">This policy has not been published yet.</p>
          <p className="text-sm">
            The store owner can add the full text from the admin dashboard (Content → Legal). No placeholder legal
            language is shown here on purpose.
          </p>
        </div>
      )}
      <Link to="/" className="inline-block mt-12 font-mono-label text-xs uppercase tracking-luxe text-white/50 hover:text-white border-b border-white/30 pb-1">
        ← Back home
      </Link>
    </div>
  );
}
